/**
 * 设置图表图例独立文本
 */
export const hostSeriesData = [
  { value: 70, name: "第一象限" },
  { value: 10, name: "第二象限" },
  { value: 10, name: "第三象限" },
  { value: 10, name: "第四象限" },
]
/**
 * 图表配置项
 */
export const Option = {
  barOption: {
    xAxis: {
      type: "category",
      data: ["总数", "在线", "报警", "离线"],
      axisLine: {
        show: true,
        lineStyle: {
          color: "#3845A1",
        },
      },
    },
    yAxis: {
      type: "value",
      // Y轴网格线
      splitLine: {
        show: true,
        lineStyle: {
          color: "#3845A1",
        },
      },
      // Y轴轴线
      axisLine: {
        show: false,
      },
      // Y轴刻度值
      axisLabel: {
        show: false,
      },
    },
    series: [
      {
        data: [
          {
            value: "",
            // 设置单个柱子的样式
            itemStyle: {
              color: "#1BB78A",
            },
          },
          {
            value: "",
            itemStyle: {
              color: "#4CA0DE",
            },
          },
          {
            value: "",
            itemStyle: {
              color: "#F63B55",
            },
          },
          {
            value: "",
            itemStyle: {
              color: "#F8AF3B",
            },
          },
        ],
        // 条柱类型和宽度
        type: "bar",
        barWidth: "30%",
        // 条柱数值显示
        label: {
          show: true,
          color: "#fff",
          position: "top",
        },
      },
    ],
    // 整体图表位置
    grid: {
      bottom: "35%",
      top: "5%",
    },
    // 全局文本样式
    textStyle: {
      color: "#fff",
    },
  },
  pieOption: {
    tooltip: {
      trigger: "item",
      show: false,
    },
    legend: {
      orient: "vertical",
      left: "80%",
      top: "50%",
      textStyle: {
        color: "#fff",
      },
    },
    series: [
      {
        type: "pie",
        radius: "50%",
        center: "30%",
        label: { show: true },
        data: [
          {
            value: "",
            // 设置单个柱子的样式
            itemStyle: {
              color: "#F9D237",
            },
            name: "",
            selected: true,
          },
          {
            value: "",
            // 设置单个柱子的样式
            itemStyle: {
              color: "#1FD09D",
            },
            name: "",
          },
        ],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      },
    ],
  },
  nestOption: {
    data: [],
    legend: {
      orient: "vertical",
      right: "75%",
      top: "40%",
      textStyle: {
        color: "#fff",
      },
    },
    series: [
      {
        type: "pie",
        radius: [80, "45%"],
        center: ["80%", "30%"],
        hoverAnimation: false,
        label: { show: false },
        data: [
          {
            value: "",
            // 设置单个柱子的样式
            itemStyle: {
              color: "#1FD09D",
            },
            name: "",
          },
          {
            value: "",
            // 设置单个柱子的样式
            itemStyle: {
              color: "#1B2362",
            },
          },
        ],
      },
      {
        type: "pie",
        radius: [39, "35%"],
        center: ["80%", "30%"],
        hoverAnimation: false,
        label: { show: false },
        data: [
          {
            value: "",
            // 设置单个柱子的样式
            itemStyle: {
              color: "#F7D037",
            },
            name: "",
          },
          {
            value: "",
            // 设置单个柱子的样式
            itemStyle: {
              color: "#1B2362",
            },
          },
        ],
      },
      {
        type: "pie",
        radius: [17, "18%"],
        center: ["80%", "30%"],
        hoverAnimation: false,
        label: { show: false },
        data: [
          {
            value: "",
            // 设置单个柱子的样式
            itemStyle: {
              color: "#F07850",
            },
            name: "",
          },
          {
            value: "",
            // 设置单个柱子的样式
            itemStyle: {
              color: "#1B2362",
            },
          },
        ],
      },
    ],
  },
  borderOption: {
    legend: {
      show: true,
      orient: "vertical",
      left: "80%",
      top: "38%",
      textStyle: {
        color: "#fff",
      },
    },
    xAxis: {
      show: false,
      type: "value",
    },
    yAxis: {
      show: false,
      type: "category",
    },
    series: [
      {
        name: "活动设备",
        type: "bar",
        barWidth: "12%",
        data: [],
        itemStyle: {
          normal: {
            barBorderRadius: [0, 15, 15, 0],
            color: "#EE7650",
          },
        },
      },
      {
        name: "已安装设备",
        type: "bar",
        barWidth: "12%",
        data: [],
        itemStyle: {
          normal: {
            barBorderRadius: [0, 15, 15, 0],
            color: "#F9D237",
          },
        },
      },
      {
        name: "总设备",
        type: "bar",
        barWidth: "12%",
        data: [],
        itemStyle: {
          normal: {
            color: "#1FD09D",
            barBorderRadius: [0, 15, 15, 0],
          },
        },
      },
    ],
    // 整体图表位置
    grid: {
      bottom: "20%",
      top: "-20%",
      width: 400,
    },
  },
  ringOption: {
    legend: {
      icon: "circle",
      orient: "vertical",
      right: "40%",
      top: "30%",
      textStyle: {
        color: "#fff",
      },
    },
    series: [
      {
        type: "pie",
        radius: [60, "73%"],
        center: ["50%", "46%"],
        hoverAnimation: false,
        label: { show: false },
        data: [
          {
            value: "",
            // 设置单个柱子的样式
            itemStyle: {
              color: "#E59800",
            },
            name: "",
          },
          {
            value: "",
            // 设置单个柱子的样式
            itemStyle: {
              color: "#1FD09D",
            },
            name: "",
          },
        ],
      },
    ],
  },
  stationOption: {
    tooltip: {
      trigger: "item",
    },
    series: [
      {
        type: "pie",
        radius: "87%",
        center: ["50%", "45%"],
        hoverAnimation: false,
        label: { show: true },
        data: [
          {
            value: "",
            // 设置单个柱子的样式
            itemStyle: {
              color: "#F9D237",
            },
            name: "",
            selected: true,
          },
          {
            value: "",
            // 设置单个柱子的样式
            itemStyle: {
              color: "#1FD09D",
            },
            name: "",
          },
        ],
      },
    ],
  },
  roseWOption: {
    tooltip: {
      show: true,
    },
    legend: {
      top: "30%",
      left: "15%",
      align: "right",
      orient: "vertical",
      textStyle: {
        color: "#fff",
      },
    },
    series: [
      {
        type: "pie",
        radius: [],
        center: ["65%", "50%"],
        roseType: "area",
        label: { show: false },
        hoverAnimation: true,
        data: [
          {
            value: "",
            itemStyle: {
              color: "#11B7C5",
            },
            name: "总无功功率",
          },
          {
            value: "",
            itemStyle: {
              color: "#3B57C4",
            },
            name: "A相无功功率",
          },
          {
            value: "",
            itemStyle: {
              color: "#CA921A",
            },
            name: "B相无功功率",
          },
          {
            value: "",
            itemStyle: {
              color: "#0835B2",
            },
            name: "C相无功功率",
          },
        ],
      },
    ],
  },
  roseYOption: {
    tooltip: {
      show: true,
    },
    legend: {
      top: "30%",
      left: "15%",
      align: "right",
      orient: "vertical",
      textStyle: {
        color: "#fff",
      },
    },
    series: [
      {
        type: "pie",
        radius: [],
        center: ["65%", "50%"],
        roseType: "area",
        label: { show: false },
        hoverAnimation: true,
        data: [
          {
            value: "30",
            itemStyle: {
              color: "#11B7C5",
            },
            name: "总有功功率",
          },
          {
            value: "25",
            itemStyle: {
              color: "#3B57C4",
            },
            name: "A相有功功率",
          },
          {
            value: "23",
            itemStyle: {
              color: "#CA921A",
            },
            name: "B相有功功率",
          },
          {
            value: "20",
            itemStyle: {
              color: "#0835B2",
            },
            name: "C相有功功率",
          },
        ],
      },
    ],
  },
  retOption: {
    tooltip: {
      show: true,
      formatter: "{b}:{c} kvarh",
    },
    legend: {
      top: "30%",
      left: "15%",
      align: "left",
      orient: "vertical",
      textStyle: {
        color: "#fff",
      },
      formatter: (name) => {
        const target = hostSeriesData.find((item) => item.name === name)
          ? hostSeriesData.find((item) => item.name === name).value
          : null
        const arr = [name, " " + " " + target]
        if (target !== "NA") {
          arr.push(" kvarh")
        }
        return arr.join("")
      },
    },
    series: [
      {
        type: "pie",
        radius: [0, 75],
        center: ["65%", "50%"],
        roseType: "area",
        label: { show: false },
        hoverAnimation: true,
        data: [
          {
            value: "kvarh",
            itemStyle: {
              color: "#11B7C5",
            },
            name: "第一象限",
          },
          {
            value: "kvarh",
            itemStyle: {
              color: "#3B57C4",
            },
            name: "第二象限",
          },
          {
            value: "kvarh",
            itemStyle: {
              color: "#CA921A",
            },
            name: "第三象限",
          },
          {
            value: "kvarh",
            itemStyle: {
              color: "#0835B2",
            },
            name: "第四象限",
          },
        ],
      },
    ],
  },
  videoOption: {
    tooltip: {
      trigger: "item",
    },
    legend: {
      top: "85%",
      right: "3%",
      textStyle: {
        color: "#fff",
      },
    },
    series: [
      {
        type: "pie",
        radius: "65%",
        center: ["50%", "48%"],
        hoverAnimation: true,
        label: { show: true },
        data: [
          {
            value: "5",
            // 设置单个柱子的样式
            itemStyle: {
              color: "#F9D237",
            },
            name: "故障",
          },
          {
            value: "3",
            // 设置单个柱子的样式
            itemStyle: {
              color: "#1FD09D",
            },
            name: "在线",
          },
          {
            value: "8",
            // 设置单个柱子的样式
            itemStyle: {
              color: "#3B57C4",
            },
            name: "离线",
          },
        ],
      },
    ],
  },
}
/**
 * 图表函数
 * @param {object} e echarts实例对象
 * @param {string} id 容器id
 * @param {object} data 图表所需数据
 */
export function getEchart (e, id, data) {
  var chartDom = document.getElementById(id)
  var myChart = e.init(chartDom)
  myChart.setOption(data)
}
